const E = {
  STRUCTURED_SERVICE_ITEM: "STRUCTURED_SERVICE_ITEM",
  FREE_FORM_SERVICE_ITEM: "FREE_FORM_SERVICE_ITEM"
};
export {
  E as ServiceTypeEnum
};
